var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useRef, useMemo, useEffect } from 'react';
import { createPortal } from 'react-dom';
var toggleChildren = function (_a) {
    var aboveAppDiv = _a.aboveAppDiv, belowAppDiv = _a.belowAppDiv, aboveAppChild = _a.aboveAppChild, belowAppChild = _a.belowAppChild, action = _a.action;
    if (aboveAppDiv && aboveAppChild.current) {
        aboveAppDiv[action](aboveAppChild.current);
    }
    if (belowAppDiv && belowAppChild.current) {
        belowAppDiv[action](belowAppChild.current);
    }
};
var appendChildren = function (opts) {
    return function () { return toggleChildren(__assign(__assign({}, opts), { action: 'appendChild' })); };
};
var removeChildren = function (opts) {
    return function () { return toggleChildren(__assign(__assign({}, opts), { action: 'removeChild' })); };
};
var usePortal = function (aboveAppPortalId, belowAppPortalId) {
    if (aboveAppPortalId === void 0) { aboveAppPortalId = 'above-app-portal'; }
    if (belowAppPortalId === void 0) { belowAppPortalId = 'below-app-portal'; }
    var aboveAppDiv = document.getElementById(aboveAppPortalId);
    var belowAppDiv = document.getElementById(belowAppPortalId);
    var aboveAppChild = useRef(document.createElement('div'));
    var belowAppChild = useRef(document.createElement('div'));
    return useMemo(function () {
        var handleAppendChildren = appendChildren({
            aboveAppDiv: aboveAppDiv,
            belowAppDiv: belowAppDiv,
            aboveAppChild: aboveAppChild,
            belowAppChild: belowAppChild,
        });
        var handleRemoveChildren = removeChildren({
            aboveAppDiv: aboveAppDiv,
            belowAppDiv: belowAppDiv,
            aboveAppChild: aboveAppChild,
            belowAppChild: belowAppChild,
        });
        var AboveAppPortal = function (_a) {
            var children = _a.children;
            return createPortal(children, aboveAppChild.current);
        };
        var BelowAppPortal = function (_a) {
            var children = _a.children;
            return createPortal(children, belowAppChild.current);
        };
        var useTogglePortalRoot = function () {
            return useEffect(function () {
                handleAppendChildren();
                return handleRemoveChildren;
            }, []);
        };
        return {
            AboveAppPortal: AboveAppPortal,
            BelowAppPortal: BelowAppPortal,
            useTogglePortalRoot: useTogglePortalRoot,
            handleAppendChildren: handleAppendChildren,
            handleRemoveChildren: handleRemoveChildren,
        };
    }, [aboveAppDiv, belowAppDiv]);
};
export default usePortal;
//# sourceMappingURL=index.js.map